module.exports = __webpack_public_path__ + "055f998d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/src/src_img/partnerships_ikea@2x.png
// module id = 1203
// module chunks = 0